import { observer } from 'mobx-react-lite';
import * as React from 'react';
import StepperModel from '../models/StepperModel';
import { STEP_SITE_BUILDER } from '../steps/steps-definitions';
import SiteBuilderModel from '../steps/SiteBuilder/model/SiteBuilderModel';

interface FCProps {}

const PageContainer: React.FC<React.PropsWithChildren<FCProps>> = observer(
  ({ children }) => {
    if (StepperModel.currentStep === STEP_SITE_BUILDER) {
      return (
        <div className="flex justify-center flex-1">
          <div
            className={
              SiteBuilderModel.iframeVisibility
                ? 'w-full flex flex-col'
                : 'p-2 pt-[32px] md:pt-[60px] w-full flex flex-col px-[40px] md:px-[105px] xl:px-[180px]'
            }
          >
            {children}
          </div>
        </div>
      );
    }

    return (
      <div className="flex items-start items-center justify-start sm:justify-center sm:text-center flex-1 min-h-[1vh]">
        <div className="w-full max-w-[1200px] min-h-[1vh] px-[40px] md:px-[105px] xl:px-[180px] py-[32px] md:py-[60px] overflow-hidden">
          <div>{children}</div>
        </div>
      </div>
    );
  }
);

export default PageContainer;
